const footerLogo = document.querySelector('[data-footer-logo] svg');
if (footerLogo) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.body.classList.add('hide-nav');
      } else {
        document.body.classList.remove('hide-nav');
      }
    });
  }, {
    threshold: 0.01 // Trigger when at least 10% of the element is visible
  });

  observer.observe(footerLogo);
}

const footerLogoWrapper = document.querySelector('[data-footer-logo]');
if (footerLogoWrapper) {
  const logo = footerLogoWrapper.querySelector('.footer__logo-container');

  const logoClone = logo.cloneNode(true);
  footerLogoWrapper.appendChild(logoClone);

  gsap.set(footerLogoWrapper, {
    position: 'relative',
    overflow: 'hidden',
    width: '100%'
  });

  gsap.set(logo, {
    position: 'absolute',
    left: 0
  });

  gsap.set(logoClone, {
    position: 'absolute',
    left: window.innerWidth
  });

  const logoAnimation = gsap.timeline({
    paused: true,
    repeat: 1
  });

  logoAnimation.to([logo, logoClone], {
    x: -window.innerWidth,
    duration: 8,
    ease: "none",
    onComplete: function () {
      gsap.set([logo, logoClone], { x: 0 });
      logoAnimation.pause(0);
    }
  });

  logo.addEventListener('mouseenter', () => {
    if (logoAnimation.progress() === 0) {
      logoAnimation.play();
    }
  });
}

const scrollUpButton = document.querySelector('footer .scrollup');
if (scrollUpButton) {
  scrollUpButton.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}


const popup = document.querySelector('[data-newsletter-popup]');

if (popup) {
  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  };

  const getCookie = name => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  };

  // Show/hide logic
  const showPopup = () => {
    if (window.scrollY < window.innerHeight * 1.2) {
      const onScrollToShow = () => {
        if (window.scrollY >= window.innerHeight) {
          popup.style.display = 'flex';
          setTimeout(() => {
            popup.classList.add('is-visible');
          }, 100);
          document.body.classList.add('newsletter-popup-open');
          window.removeEventListener('scroll', onScrollToShow);
        }
      };
      window.addEventListener('scroll', onScrollToShow);
      return;
    }
    popup.style.display = 'flex';
    setTimeout(() => {
      popup.classList.add('is-visible');
    }, 100);
    document.body.classList.add('newsletter-popup-open');
  };

  const hidePopup = () => {
    popup.style.display = 'none';
    document.body.classList.remove('newsletter-popup-open');
    setTimeout(() => {
      popup.classList.remove('is-visible');
    }, 300);
    setCookie('newsletter_popup_closed', '1', 30); // Hide for 30 days
  };

  const maybeShowPopup = () => {
    if (getCookie('newsletter_popup_closed')) return;
    const openSetting = popup.getAttribute('data-popup-open');
    if (openSetting === 'onLoad') {
      showPopup();
    } else if (openSetting === 'onScroll') {
      const onScroll = () => {
        if (window.scrollY > 200) {
          showPopup();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll);
    } else if (openSetting === 'afterDelay') {
      setTimeout(showPopup, 10000);
    }
  };

  const closeBtn = popup.querySelector('.newsletter-popup__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', hidePopup);
  }

  // TODO: Handle form submission
  const form = popup.querySelector('.newsletter-popup__form');
  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();
      hidePopup();
    });
  }

  // Init
  maybeShowPopup();
}